import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { layoutDefaults } from '../../utils/layout-defaults';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function usePaymentConfirmedModal() {
  const storage = useStorage();
  const { t } = useTranslation();
  const { spot } = storage;
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({
    storage,
    includesTitleBottomMargin: spot?.prepaid !== true,
  });

  function didOpen() {
    analyticsPageView('Payment Confirmed');
  }

  async function show() {
    const result = await swal.fire({
      title: spot?.prepaid
        ? t('payment-confirmed-modal.title.prepaid')
        : t('payment-confirmed-modal.title'),
      text: spot?.prepaid ? t('payment-confirmed-modal.text') : null,
      icon: 'success',
      timer: spot?.prepaid ? null : layoutDefaults.modalTimer,
      didOpen,
      showConfirmButton: spot?.prepaid === true,
      showDenyButton: false,
      showCancelButton: false,
    });

    return result;
  }

  return {
    showPaymentConfirmedModal: show,
  };
}

export { usePaymentConfirmedModal };
